import { useCallback, useRef, useState } from 'react';

export const useAugmentedState = <T>(initialState: T): [T, React.Dispatch<React.SetStateAction<T>>, React.RefObject<T>] => {
  const stateRef = useRef<T>(initialState);
  const [state, _setState] = useState<T>(initialState);

  const setState: React.Dispatch<React.SetStateAction<T>> = useCallback((value) => {
    _setState((prev) => {
      const next = typeof value === 'function' ? (value as (prevState: T) => T)(prev) : value;
      stateRef.current = next;
      return next;
    });
  }, []);

  return [state, setState, stateRef];
};
